import React, { useEffect } from 'react'
import WhyChooseUs from '../Components/Home/WhyChooseUs'
import { useSEO } from './Seo'
import FirstSection from '../Components/Home/FirstSection'
import HeroSection from '../Components/Home/HeroSection'
import FeaturedSection from '../Components/Home/FeaturedSection'
import GameGallery from '../Components/Home/GameGallary'
import { Helmet } from 'react-helmet'
import BlogList from '../Components/BlogList'

const Home = () => {

const STORAGE_KEY = "gameListPage"

useSEO({
  title: "Play Free Online Games | Best Online Games at Game Zone Hub",
  description: "Looking to play free online games? Discover thousands of the best online games including action, puzzle, and arcade. No downloads required, just play free online instantly at Game Zone Hub!",
  keywords: "play free online games, online games, play free online, free browser games, play games online free, Game Zone Hub",
  canonical: "https://www.gamezonehub.in/",
  ogTitle: "Play Free Online Games | Game Zone Hub",
  ogDescription: "Play the best free online games instantly. Action, puzzle, racing, and more. No downloads, just play free online!",
  ogImage: "https://www.gamezonehub.in/og-image.webp",
  twitterCard: "summary_large_image",
});

const schemaData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Game Zone Hub",
  "url": "https://www.gamezonehub.in/",
  "description": "Play free online games instantly. The ultimate hub for online games without any downloads.",
};


useEffect(()=>{
  localStorage.setItem(STORAGE_KEY, String(1))
  window.scrollTo({top:"0"})
},[])

  return (
    <div className='bg-gradient-to-br from-gray-900 via-black to-gray-800 min-h-screen pt-[80px] '>
         <Helmet>
           {schemaData && (
             <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />
           )}
         </Helmet>

         <FirstSection/>
         <HeroSection/>
         <FeaturedSection/>
         <WhyChooseUs/>
         <GameGallery/>
         <BlogList/>

         {/* EXTENDED HOME PAGE SEO CONTENT BLOCK FOR ADSENSE APPROVAL */}
         <section className="bg-[#0b1120] border-t border-white/5 py-16 px-4" data-aos="fade-up">
           <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12">
             <div className="space-y-6">
               <h2 className="text-3xl font-extrabold text-white">Why Play Free Online Games at Game Zone Hub?</h2>
               <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full"></div>
               <div className="text-gray-300 leading-relaxed space-y-4 text-sm sm:text-base">
                 <p>
                   Game Zone Hub is your premier destination for high-quality, instant entertainment. In today's fast-paced world, you don't always have the time or storage space to download massive game files or deal with lengthy installations. That's why we have created the ultimate platform to <strong>play free online games</strong> directly in your web browser. 
                 </p>
                 <p>
                   Our team handpicks the most engaging HTML5 browser games from top developers around the globe. This ensures that every time you visit Game Zone Hub, you are met with a curated selection of premium <strong>online games</strong> that run flawlessly whether you are on a desktop PC, a laptop, a tablet, or a mobile smartphone.
                 </p>
                 <p>
                   We believe that gaming should be accessible to everyone, everywhere. That's why our platform is 100% free. You can enjoy everything from intense action games and complex puzzle challenges to relaxing arcade titles—all without ever opening your wallet. 
                 </p>
               </div>
             </div>
             
             <div className="space-y-6">
               <h2 className="text-3xl font-extrabold text-white">Explore Trending Game Categories</h2>
               <div className="w-20 h-1 bg-gradient-to-r from-purple-500 to-pink-400 rounded-full"></div>
               <div className="space-y-4 text-gray-300 text-sm sm:text-base">
                 <div className="bg-white/5 p-5 rounded-xl border border-white/5 hover:border-white/20 transition-colors">
                   <h3 className="font-bold text-lg text-blue-300 mb-2">🚗 Thrilling Racing Games</h3>
                   <p>Experience the thrill of high-speed chases, 3D driving simulators, and off-road dirt tracks. Test your reflexes and become the ultimate racer without any downloads.</p>
                 </div>
                 <div className="bg-white/5 p-5 rounded-xl border border-white/5 hover:border-white/20 transition-colors">
                   <h3 className="font-bold text-lg text-purple-300 mb-2">🧩 Brain-Teasing Puzzles</h3>
                   <p>Challenge your mind with complex logic puzzles, classic Solitaire, match-3 games, and strategy board games. Perfect for keeping your brain sharp.</p>
                 </div>
                 <div className="bg-white/5 p-5 rounded-xl border border-white/5 hover:border-white/20 transition-colors">
                   <h3 className="font-bold text-lg text-green-300 mb-2">⚔️ Action & Arcade</h3>
                   <p>Jump into fast-paced gameplay, fight waves of enemies, and climb the leaderboards in our endless library of classic arcade and action hits.</p>
                 </div>
               </div>
             </div>
           </div>
           
           <div className="max-w-7xl mx-auto mt-12 bg-black/40 p-8 rounded-3xl border border-white/10 text-center">
             <h3 className="text-2xl font-bold text-white mb-4">Start Playing Now</h3>
             <p className="text-gray-400 mb-6 max-w-3xl mx-auto text-sm sm:text-base">
               Join thousands of daily players on Game Zone Hub. Your next favorite game is just a click away. Browse our categories, utilize our search feature, or simply pick from our Editor's Choice below to start your adventure.
             </p>
           </div>
         </section>

    </div>
  )
}

export default Home
